export default "__VITE_ASSET__DQG_Famk__"